import { dia as Dia, shapes } from 'libs/rappid/build/rappid';

shapes.basic.Rect.define('cyberThing.DataSelector',
	{
		type: 'cyberThing.DataSelector',
		size: { width: 220, height: 710 }
	}
);